/**
 * EngagementCluster — the slot for likes, share, save and more on the event page.
 *
 * None of those actions is wired yet (event_likes, counter cache and the auth-gated mutation ship with
 * VIEWER_AUTH_SPEC.md), so the slot renders nothing: buttons that do nothing and an invented like count are not
 * honest state (design/DESIGN.md). Layouts and the Director's controls keep the slot and its config for when it is.
 */

import {
  registerPrimitive,
  type PrimitiveProps,
} from '../../layout'

export function EngagementCluster(_props: PrimitiveProps) {
  return null
}

registerPrimitive('EngagementCluster', EngagementCluster)
